import { DEALER_FETCH_SUCCESS, DEALERS_FETCH_SUCCESS, DEALER_FETCH_RESET, DEALERS_FETCH_RESET } from '../actions/types';

const INIT_STATE = {
  dealers: [],
  dealer: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case DEALERS_FETCH_SUCCESS: {
      // DO NOT CLEAR `dealer` HERE. THE EDIT PAGE LOADS THE SINGLE DEALER AND
      // THE DEALER LIST AT THE SAME TIME (THE LIST FEEDS THE PROVINCE OPTIONS
      // AND THE DUPLICATE dealer_code CHECK), AND HeaderFilter FETCHES THE LIST
      // TOO. CLEARING IT DROPPED initialValues AND enableReinitialize THEN
      // BLANKED THE FORM A MOMENT AFTER IT RENDERED.
      // THE ADD PAGE CLEARS IT EXPLICITLY VIA dealerFetchReset().
      return {
        ...state,
        dealers: action.payload,
      };
    }
    case DEALER_FETCH_SUCCESS: {
      return {
        ...state,
        dealer: action.payload,
      };
    }
    case DEALERS_FETCH_RESET: {
      return {
        ...state,
        dealers: [],
      };
    }
    case DEALER_FETCH_RESET: {
      return {
        ...state,
        dealer: {},
      };
    }
    default:
      return state;
  }
};
